import React, {useEffect, useMemo, useState} from "react";
import moment from "moment";
import {Calendar, DateRange, momentLocalizer, ToolbarProps} from "react-big-calendar";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import './style.css';
import {fetchSchedule} from "features/model/service/groups/schedule/fetchSchedule";
import {useAppDispatch, useAppSelector} from "common/hook";
import 'moment/locale/ru';
import {
    CustomModal
} from "components/pages/groups/group-container/students/students-pages/students-timetable/custom-modal/CustomModal";
import {
    CustomToolbar
} from "components/pages/groups/group-container/students/students-pages/students-timetable/custom-toolbar/CustomToolbar";
import {useParams} from "react-router-dom";
import {formatDate} from "common/utils/calendar/dateUtils";
import EventComponent
    from "components/pages/groups/group-container/students/students-pages/students-timetable/event-component/EventComponent";
import {handleShowMore} from "common/utils/calendar/handleShowMore";
import {EventType} from "features/model/types/EventType";
import {handleSelectSlot} from "common/utils/calendar/handleSelectSlot";


moment.locale("ru");
const localizer = momentLocalizer(moment);

export const StudentsTimetable = () => {
    const dispatch = useAppDispatch();
    const {groupId} = useParams();
    const pendingFilters = useAppSelector((state) => state.filers);
    const scheduleData = useAppSelector(state => state.schedule)
    const [eventsData, setEventsData] = useState<any[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedEvents, setSelectedEvents] = useState<any[]>([]);
    const [selectedTimeZone, setSelectedTimeZone] = useState<string | null>(null);
    const [currentMonthYear, setCurrentMonthYear] = useState(new Date());
    const [starting, setStarting] = useState(new Date());
    const [sendFilter, setSendFilter] = useState<boolean>(false)




    const handleShowMoreEvents = (events: EventType[], date: Date) => {
        handleShowMore(events, eventsData, setSelectedEvents, setIsModalOpen);
        setStarting(date)
    };

    const customHandleSelectSlot = ({start, end}: DateRange) => {
        handleSelectSlot(start, end, eventsData, setSelectedEvents, setIsModalOpen, setStarting);
    };


    useEffect(() => {
        if (scheduleData.data && typeof scheduleData.data === 'object') {
            const newEventsData = Object.values(scheduleData.data).flatMap((eventGroup) => (
                eventGroup.map((event) => ({
                    id: event.id,
                    title: event.title,
                    start: new Date(event.startAt),
                    end: new Date(event.finishAt),
                    status: event.status,
                    problems: event.problems,
                    hasProblem: event.hasProblems,
                }))
            ));

            setEventsData(newEventsData);
        }
    }, [scheduleData]);



    const getMonthNumber = (date: Date) => {
        return date.getMonth() + 1;
    };

    const fetchScheduleData = (newDate: Date) => {
        setCurrentMonthYear(newDate)
        const month = getMonthNumber(newDate).toString();
        const year = newDate.getFullYear().toString();
        dispatch(fetchSchedule({
            month: month,
            year: year,
            time_zone: selectedTimeZone,
            new: pendingFilters?.isNew ? 1 : 0,
            finished: pendingFilters?.finished ? 1 : 0,
            has_problem: pendingFilters?.has_problem ? 1 : 0,
            groupId: groupId
        }));
    };



    useEffect(() => {
        const month = getMonthNumber(currentMonthYear).toString();
        const year = currentMonthYear.getFullYear().toString();
        dispatch(fetchSchedule({
            month: month,
            year: year,
            time_zone: selectedTimeZone,
            new: pendingFilters?.isNew ? 1 : 0,
            finished: pendingFilters?.finished ? 1 : 0,
            has_problem: pendingFilters?.has_problem ? 1 : 0,
            groupId: groupId
        }));

    }, [dispatch, sendFilter, selectedTimeZone, groupId]);

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const {components} = useMemo(() => ({
        components: {
            toolbar: (props: ToolbarProps<Event, object>) => (
                <CustomToolbar
                    onNavigate={props.onNavigate}
                    label={props.label}
                    date={props.date}
                    view={props.view}
                    views={props.views}
                    localizer={props.localizer}
                    onView={props.onView}
                    setSelectedTimeZone={setSelectedTimeZone}
                    setSendFilter={setSendFilter}
                />
            ),
            event: (props: any) => (
                <EventComponent
                    status={props.event.status}
                    hasProblem={props.event.hasProblem}
                    start={props.event.start}
                />
            ),
        }
    }), []);

    const formattedDate = formatDate(new Date(starting));

    return (
        <div className='calendarContainer'>
            <Calendar
                views={["month"]}
                selectable
                localizer={localizer}
                defaultDate={new Date()}
                defaultView="month"
                events={eventsData}
                onSelectEvent={customHandleSelectSlot}
                onSelectSlot={customHandleSelectSlot}
                onShowMore={handleShowMoreEvents}
                onNavigate={(newDate, view, action) => fetchScheduleData(newDate)}
                components={components as any}
            />
            {/*model*/}
            <CustomModal
                selectedEvents={selectedEvents}
                formattedDate={formattedDate}
                isModalOpen={isModalOpen}
                handleOk={handleOk}
                handleCancel={handleCancel}
            />

        </div>
    );
};




